import React from "react";
import "./About.css";

const About = ({ t }) => {
  return (
    <section id="about" className="section about-section">
      <h2 className="section-title">{t.about.title}</h2>
      <div className="about-content">
        <div className="about-text">
          <p>{t.about.paragraph1}</p>
          <p>{t.about.paragraph2}</p>
          <p>{t.about.paragraph3}</p>
        </div>
      </div>
    </section>
  );
};

export default About;
